import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { Urls } from '../../../../utils/catalogue/urls';
import { ApiService } from '../../../../shared/catalogue/services/api.service';
import { CommonDataService } from '../../../../shared/catalogue/services/common-data.service';
import { DATA_PER_PAGE,
         CANCEL,
         Video_deleted } from './../../../../app.constant';

@Component({
  selector: 'app-investor-video',
  templateUrl: './investor-video.component.html',
  styleUrls: ['./investor-video.component.scss'],
})
export class InvestorVideoComponent implements OnInit {
  @Input() data: any[];

  @Output() editChange: EventEmitter<any> = new EventEmitter<any>();

  pageSize: number = DATA_PER_PAGE;

  constructor(
    public apiService: ApiService,
    private toastr: ToastrService,
    public commonDataService: CommonDataService
  ) {}

  ngOnInit() {}

  getVideos = () => {
    this.apiService
      .getData(Urls.getInvestorVideos)
      .subscribe((response: any) => {
        this.data = response.data.videoList;
      });
  };

  scrollTop = () => {
    window.scroll({
      top: 0,
      left: 0,
      behavior: 'smooth',
    });
  };

  deleteData = (id) => {
    this.commonDataService
      .confirm('Are you sure want to delete?', 'md')
      .then((confirmed) => {
        if (confirmed) {
          this.apiService
            .postData(Urls.deleteInvestorVideo, { id })
            .subscribe((response: any) => {
              console.log(response);
              this.getVideos();
            });
          this.toastr.success(Video_deleted);
        }
      })
      .catch(() => {
        this.toastr.error(CANCEL);
      });
  };

  onEdit(obj: any) {
    this.editChange.emit(obj);
    this.scrollTop();
  }
}
